import { EventService } from '@pingum/api-services';
import {
  EVENT_CHANGE_STATUS_ERROR,
  EVENT_CHANGE_STATUS_REQUESTED,
  EVENT_CHANGE_STATUS_SUCCESS,
  SELECTED_EVENT_ID_TO_UPDATE,
} from '@pingum/app-state-management/event/types';

import { dispatchNetworkRequestDynamicSuccessDispatch } from '../networkDispatcher';

// The shared changeStatus action does not return its request promise.
export const changeEventStatus = (id, status) => (dispatch) => {
  dispatch({
    type: SELECTED_EVENT_ID_TO_UPDATE,
    eventId: id,
  });
  const promise = EventService.changeStatus(id, status);
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: EVENT_CHANGE_STATUS_REQUESTED,
    successDispatch: {
      type: EVENT_CHANGE_STATUS_SUCCESS,
      eventId: id,
    },
    errorType: EVENT_CHANGE_STATUS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem changing statuses',
    responseName: 'newStatus',
  });
  return promise;
};
